// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"23b8f438","632":"243e3086","787":"cd36820a"}[chunkId] + ".chunk.js";
};